import { render, staticRenderFns } from "./stocks.vue?vue&type=template&id=c561ebd2&scoped=true&"
import script from "./stocks.vue?vue&type=script&lang=js&"
export * from "./stocks.vue?vue&type=script&lang=js&"
import style0 from "./stocks.vue?vue&type=style&index=0&id=c561ebd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561ebd2",
  null
  
)

export default component.exports